import { render, staticRenderFns } from "./BetslipErrors.vue?vue&type=template&id=74212efc"
import script from "./BetslipErrors.vue?vue&type=script&lang=js"
export * from "./BetslipErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports